import styled from 'styled-components';

import { Text, H1, Button, ButtonVariant, iconFill } from '@catalyze/ui';

export const FormTitleContainer = styled.div`
    margin-top: 2.5rem;
    margin-bottom: 1.5rem;
`;

export const FormTitle = styled(H1)`
    font-size: 1.625rem;
    font-weight: bold;
    display: inline-block;
    text-align: center;
`;

export const FormSubtitle = styled(Text)`
    margin: 1rem 0;
    color: ${({ theme }) => theme.colors.fontTertiary};
    font-size: ${({ theme }) => theme.fontSizes[4]};
    text-align: left;
`;

export const StyledButton = styled(Button).attrs({
    variant: ButtonVariant.TERTIARY,
})`
    display: inline-block;
    transform: rotateY(180deg);
    margin-right: 0.5rem;
    padding: 0.75rem;

    & > * {
        width: 1.125rem;
        height: 1.125rem;
        ${({ theme }) => iconFill(theme.colors.fontPrimary)};
    }
`;
